var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5H20C20.3978 10.5 20.7792 10.6581 21.0605 10.9395C21.3418 11.2207 21.5 11.6022 21.5 12V20C21.4999 20.3977 21.3418 20.7793 21.0605 21.0605C20.7793 21.3418 20.3978 21.5 20 21.5H4C3.60223 21.5 3.22075 21.3418 2.93945 21.0605C2.6582 20.7793 2.50006 20.3977 2.5 20V12C2.5 11.6022 2.65822 11.2207 2.93945 10.9395C3.22076 10.6581 3.60218 10.5 4 10.5ZM15.2461 11.6064L10.2998 16.5518L8.40039 14.6523L6.29004 16.7627L6.64941 17.1162L9.94922 20.3564L10.3018 20.7021L10.6523 20.3545L17.3516 13.7148L17.709 13.3613L17.3535 13.0059L15.9531 11.6064L15.5996 11.2529L15.2461 11.6064ZM19.5098 6.50977V7.50977H4.50977V6.50977H19.5098ZM17.5098 2.50977V3.50977H6.50977V2.50977H17.5098Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.9d80804d4502f02caefcaf2fb11840ce.svg";
export { ForwardRef as ReactComponent };